import domToImage from "dom-to-image-more";
import jsPDF from "jspdf";

// Wide variants of options.
/* eslint-disable @typescript-eslint/no-explicit-any */
export async function exportNodeToPng(node: HTMLElement, filename: string, options: any = {}, bgcolor = "#262945") {
  const originalOverflow = node.style.overflow;
  const originalHeight = node.style.height;

  node.style.overflow = "visible";
  node.style.height = node.scrollHeight + "px";

  try {
    const blob = await domToImage.toBlob(node, {
      bgcolor: bgcolor,
      pixelRatio: window.devicePixelRatio || 2,
      ...options,
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  } finally {
    node.style.overflow = originalOverflow;
    node.style.height = originalHeight;
  }
}

export async function exportNodeToPdf(
  node: HTMLElement,
  pdfName = "export.pdf",
  {
    bgcolor = "#262945",
    pixelRatio = window.devicePixelRatio || 2,
    options = {},
  }: {
    bgcolor?: string;
    pixelRatio?: number;
    options?: any;
  } = {}
) {
  const originalOverflow = node.style.overflow;
  const originalHeight = node.style.height;

  node.style.overflow = "visible";
  node.style.height = `${node.scrollHeight}px`;

  try {
    const blob = await domToImage.toBlob(node, {
      bgcolor,
      pixelRatio,
      ...options,
    });

    const imgUrl = URL.createObjectURL(blob);
    const img = await new Promise<HTMLImageElement>((resolve, reject) => {
      const i = new Image();
      i.onload = () => resolve(i);
      i.onerror = reject;
      i.src = imgUrl;
    });

    const w = img.naturalWidth;
    const h = img.naturalHeight;
    const orientation = h >= w ? "p" : "l";

    const pdf = new jsPDF({
      unit: "px",
      format: [w, h],
      orientation,
    });

    pdf.addImage(img, "PNG", 0, 0, w, h);
    pdf.save(pdfName);

    URL.revokeObjectURL(imgUrl);
  } finally {
    node.style.overflow = originalOverflow;
    node.style.height = originalHeight;
  }
}
